module.exports = __webpack_public_path__ + "img/avatar.e463e4a8.png";